//https://github.com/sahat/satellizer/blob/f92345f271dcc9e96e7ede0350460d093c1349a7/examples/client/vendor/satellizer.js
angular.module('harriApp')

    .directive('socialAuth', ['harri.social.auth.providers', 'httpHelper', 'registrationApi', 'asyncGlobalHandler', '$state', 'hFormReference', '$rootScope','hUser', function(authProviders, httpHelper, registrationApi, asyncGlobalHandler, $state, hFormReference, $rootScope,hUser) {
        return {
            link: function(scope, element, attrs) {
 
                element.bind('click', function() {
                    var provider = attrs.socialAuth;

                    hLoginManager.federatedSignIn(provider)
                        .then(function (res) {
                            if (res.closed) {
                                return;
                            }
                            if (res.success) {
                                hUser.getFullUserData().then(function () {
                                    hUser.login();
                                    $rootScope.$broadcast('logged-in-from-oauth', provider, res);
                                });
                            } else {
                                var error = res.details && res.details.error_description ?
                                    Utils.humanizeoAuthErrorResponse(res.details.error_description) :
                                    'Something went wrong, please try again.';

                                $rootScope.$broadcast('error-from-oauth', provider, error);

                                hLog("harri.auth.social", "socialRegistrationOrLogin", error);
                                hAlert("Error", error);
                            }
                        });

                })
            }
        }
    }])

    .factory('harri.social.auth.providers', ['harri.social.config', 'harri.social.Oauth2', function(config, Oauth2) {
        return {
            auth: function(provider) {
                return Oauth2().open(config.getProviders()[provider]);
            }
        }
    }])

    .factory('harri.social.config', ['$state', function($state) {
        var redirectUrl = $state.href('oauth2_activation_request',{code:null}, { absolute: true});
        const outlookCallbackUrl = $state.href('outlook_calendar_callback',{code:null}, { absolute: true});

        var FBAppId = publicConfiguration.keys.facebook.AppId;

        return {
            tokenName: 'token',
            getProviders: function (mode, sessionState) {
                var providers = {};

                if (mode === 'calendar') {
                    providers = {
                        google: {
                            clientId: publicConfiguration.keys.google.oauthClientId,
                            name: 'google',
                            url: publicConfiguration.getBaseAPI("InterviewServers") + 'google/callback',
                            authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
                            redirectUri: redirectUrl,
                            scope: [encodeURIComponent('https://www.googleapis.com/auth/calendar'), encodeURIComponent('https://www.googleapis.com/auth/userinfo.email')],
                            scopeDelimiter: '+',
                            accessType: 'offline',
                            state: sessionState,
                            includeGrantedScopes: true,
                            requiredUrlParams: ['scope', 'access_type', 'include_granted_scopes', 'state'],
                            optionalUrlParams: ['display'],
                            display: 'popup',
                            type: '2.0',
                            popupOptions: { width: 452, height: 633 },
                            response_at_key: "access_token"
                        },
                        outlook: {
                            clientId: publicConfiguration.keys.outlook.oauthClientId,
                            name: 'outlook',
                            url: publicConfiguration.getBaseAPI("InterviewServers") + 'outlook/callback',
                            authorizationEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
                            redirectUri: outlookCallbackUrl,
                            scope: ["https://graph.microsoft.com/Calendars.ReadWrite", "https://graph.microsoft.com/User.Read", 'offline_access'],
                            scopeDelimiter: '+',
                            requiredUrlParams: ['scope'],
                            responseMode: 'query',
                            optionalUrlParams: ['response_mode'],
                            type: '2.0',
                            popupOptions: { width: 452, height: 633 },
                            response_at_key: "access_token"
                        }
                    }
                }
                else if (mode == 'pages') {
                    providers = {
                        facebook: {
                            clientId: FBAppId,
                            url: 'auth_facebook/auth',
                            authorizationEndpoint: 'https://www.facebook.com/dialog/oauth',
                            redirectUri: redirectUrl,
                            scope: ['manage_pages','publish_pages'],
                            scopeDelimiter: ',',
                            requiredUrlParams: ['display', 'scope'],
                            display: 'popup',
                            type: '2.0',
                            popupOptions: { width: 481, height: 269 },
                            response_at_key: "access_token",
                            api_key: ['facebook_api_key', FBAppId]
                        }
                    }
                }
                else if (mode == 'backgroundCheck') {
                    providers = {
                        checkr: {
                            clientId: publicConfiguration.keys.checkr['oauthClientId'],
                            authorizationEndpoint: 'https://partners.' + publicConfiguration.keys.checkr['checkrDomain'] + '/authorize/' + publicConfiguration.keys.checkr['oauthClientId'] + '/signin',
                            redirectUri: redirectUrl,
                            scope: ['read_write'],
                            scopeDelimiter: ',',
                            requiredUrlParams: ['scope'],
                            type: '2.0',
                            popupOptions: {width: 481, height: 269},
                            response_at_key: "access_token",
                            responseType: "token",
                            tokenName: "token",
                        }
                    }
                }
                else {
                    providers = {
                        linkedin: {
                            clientId: publicConfiguration.keys.linkedin.APIKey,
                            url: 'auth_linkedin/auth',
                            authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
                            redirectUri: redirectUrl,
                            requiredUrlParams: ['scope'],
                            scope: publicConfiguration.keys.linkedin.permissions,
                            scopeDelimiter: ',',
                            state: 'STATE',
                            type: '2.0',
                            popupOptions: { width: 527, height: 582 },
                            response_at_key: "oauth2_access_token"
                        },
                        facebook: {
                            clientId: FBAppId,
                            url: 'auth_facebook/auth',
                            authorizationEndpoint: 'https://www.facebook.com/dialog/oauth',
                            redirectUri: redirectUrl,
                            scope: publicConfiguration.keys.facebook.permissions,
                            scopeDelimiter: ',',
                            requiredUrlParams: ['display', 'scope'],
                            display: 'popup',
                            type: '2.0',
                            popupOptions: { width: 481, height: 269 },
                            response_at_key: "access_token",
                            api_key: ['facebook_api_key', FBAppId]
                        },
                        google: {
                            clientId: publicConfiguration.keys.google.oauthClientId,
                            name: 'google',
                            url: 'auth_google/auth',
                            authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
                            redirectUri: redirectUrl,
                            scope: ['profile', 'email'],
                            scopePrefix: 'openid',
                            scopeDelimiter: ' ',
                            requiredUrlParams: ['scope'],
                            optionalUrlParams: ['display'],
                            display: 'popup',
                            type: '2.0',
                            popupOptions: { width: 452, height: 633 },
                            response_at_key: "access_token"
                        },
                        indeed: {
                            clientId: publicConfiguration.keys.indeed.clientId,
                            name: 'indeed',
                            authorizationEndpoint: 'https://secure.indeed.com/oauth/v2/authorize',
                            redirectUri: redirectUrl,
                            scope: ['email', 'offline_access', 'employer_access', 'employer.advertising.campaign', 'employer.advertising.account.read'],
                            scopeDelimiter: '+',
                            state: 'harri',
                            prompt: 'select_employer',
                            requiredUrlParams: ['scope', 'state', 'prompt'],
                            optionalUrlParams: ['display'],
                            display: 'popup',
                            type: '2.0',
                            popupOptions: { width: 452, height: 633 },
                            response_at_key: "access_token",
                            exchangeForToken: false
                        },
                    };
                }

                return providers;
            }
        }
    }])

    .factory('harri.social.popup', [
        '$q',
        '$interval',
        '$window',
        '$location',
        'harri.social.utils',
        function($q, $interval, $window, $location, utils) {
            var popupWindow = null;
            var polling = null;

            var popup = {};

            popup.popupWindow = popupWindow;

            popup.open = function(url, options) {
                var deferred = $q.defer();
                var optionsString = popup.stringifyOptions(popup.prepareOptions(options || {}));

                popupWindow = window.open(url, '_blank', optionsString);

                if (popupWindow && popupWindow.focus) {
                    popupWindow.focus();
                }

                popup.pollPopup(deferred);

                return deferred.promise;
            };

            popup.pollPopup = function(deferred) {
                polling = $interval(function() {
                    try {
                        if (popupWindow.document.domain === document.domain && (popupWindow.location.search || popupWindow.location.hash)) {
                            var queryParams = popupWindow.location.search.substring(1).replace(/\/$/, '');
                            var hashParams = popupWindow.location.hash.substring(1).replace(/\/$/, '');
                            var hash = utils.parseQueryString(hashParams);
                            var qs = utils.parseQueryString(queryParams);

                            angular.extend(qs, hash);

                            if (qs.error) {
                                deferred.reject({ error: qs.error });
                            } else {
                                deferred.resolve(qs);
                            }

                            popupWindow.close();
                            $interval.cancel(polling);
                        }
                    } catch (error) {
                        // Do nothing here, usually security error trying to access window from cross origin
                    }

                    if (popupWindow.closed) {
                        $interval.cancel(polling);
                        deferred.reject({ error: 'Authorization Failed' });
                    }
                }, 35);
            };

            popup.prepareOptions = function(options) {
                var width = options.width || 500;
                var height = options.height || 500;
                return angular.extend({
                    width: width,
                    height: height,
                    left: $window.screenX + (($window.outerWidth - width) / 2),
                    top: $window.screenY + (($window.outerHeight - height) / 2.5)
                }, options);
            };

            popup.stringifyOptions = function(options) {
                var parts = [];
                angular.forEach(options, function(value, key) {
                    parts.push(key + '=' + value);
                });
                return parts.join(',');
            };

            return popup;
    }])

    .service('harri.social.utils', function() {

        this.camelCase = function(name) {
            return name.replace(/([\:\-\_]+(.))/g, function(_, separator, letter, offset) {
                return offset ? letter.toUpperCase() : letter;
            });
        };

        this.parseQueryString = function(keyValue) {
            var obj = {}, key, value;
            angular.forEach((keyValue || '').split('&'), function(keyValue) {
                if (keyValue) {
                    value = keyValue.split('=');
                    key = decodeURIComponent(value[0]);
                    obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
                }
            });
            return obj;
        };

    })

    .factory('harri.social.Oauth2', [
    '$q',
    'httpHelper',
    'harri.social.popup',
    'harri.social.utils',
    'harri.social.config',
    function($q, httpHelper, popup, utils, config) {
        return function() {

            var defaults = {
                url: null,
                name: null,
                scope: null,
                scopeDelimiter: null,
                clientId: null,
                redirectUri: null,
                popupOptions: null,
                authorizationEndpoint: null,
                requiredUrlParams: null,
                optionalUrlParams: null,
                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
                responseType: 'code',
                exchangeForToken: true
            };

            var oauth2 = {};

            oauth2.open = function(options, userData) {
                angular.extend(defaults, options);
                var deferred = $q.defer();
                var url = oauth2.buildUrl();
                popup.open(url, defaults.popupOptions)
                    .then(function(oauthData) {
                        if (defaults.responseType === 'token') {
                            var response = { data: {} };
                            response.data[config.tokenName] = oauthData.access_token || oauthData.code ;
                            deferred.resolve(response);
                        } else {
                            if (defaults.exchangeForToken) {
                                oauth2.exchangeForToken(oauthData, userData)
                                    .then(function(response) {
                                        deferred.resolve(response);
                                    })
                                    .catch(function(err) {
                                        hLog("harri.auth.social", "exchangeForToken", err);
                                    });

                                return;
                            }

                            deferred.resolve(oauthData);
                        }
                    })
                    .catch(function(err) {
                        hLog("harri.auth.social", "popup.open", err);
                    });

                return deferred.promise;
            };

            oauth2.exchangeForToken = function(oauthData, userData) {
                var defer = $q.defer();

                var data = angular.extend({}, userData, {
                    code: oauthData.code,
                    clientId: defaults.clientId,
                    redirectUri: defaults.redirectUri
                });

                //add custom data to backend request (in Facebook case, we need to specify the app id)
                if(defaults.api_key) {
                    data[defaults.api_key[0]] = defaults.api_key[1];
                }

                httpHelper.p(defaults.url, data).then(function(oauthData) {
                    if(oauthData.data.status_code == 200 || oauthData.data.data == "success" ) {

                        var response = { data: {} };
                        //always return a pre fixed key/token name
                        response.data[config.tokenName] = oauthData.data.data[ defaults['response_at_key'] ];
                        defer.resolve(response);

                    } else {

                        defer.reject(oauthData);

                    }
                }, function(r) {
                    defer.reject(r);
                });

                return defer.promise;
            };

            oauth2.buildUrl = function() {
                var baseUrl = defaults.authorizationEndpoint;
                var qs = oauth2.buildQueryString();
                return [baseUrl, qs].join('?');
            };

            oauth2.buildQueryString = function() {
                var keyValuePairs = [];
                var urlParams = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];

                angular.forEach(urlParams, function(params) {
                    angular.forEach(defaults[params], function(paramName) {
                        var camelizedName = utils.camelCase(paramName);
                        var paramValue = defaults[camelizedName];

                        if (paramName === 'scope' && Array.isArray(paramValue)) {
                            paramValue = paramValue.join(defaults.scopeDelimiter);

                            if (defaults.scopePrefix) {
                                paramValue = [defaults.scopePrefix, paramValue].join(defaults.scopeDelimiter);
                            }
                        }

                        keyValuePairs.push([paramName, paramValue]);
                    });
                });

                return keyValuePairs.map(function(pair) {
                    return pair.join('=');
                }).join('&');
            };

            return oauth2;
        };
    }])

    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state('oauth2_activation_request', {
                url: "/oauth2/?code&state"
            })
            .state('outlook_calendar_callback', {
                url: "/outlook-calendar/callback?code"
            })
    }])
    .config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state('direct_oauth2_activation_request', {
                url: "/oauth2/direct/?code&state&redirect",
                onEnter: ['$rootScope', 'hUser', 'httpHelper', '$stateParams', function ($rootScope, hUser, httpHelper, $stateParams) {

                    httpHelper.p('auth_linkedin/auth', {
                        'clientId': publicConfiguration.keys.linkedin.APIKey,
                        'code': $stateParams.code,
                        'redirectUri': 'https://harri.com/oauth2/direct/'
                    }).then(function (response) {

                        if (response.data.data.oauth2_access_token) {
                            var accessToken = response.data.data.oauth2_access_token;
                            var utmParams = HStorageManager.get({
                                storageLevel: HStorageManager.StorageLevels.COOKIES,
                                key: 'tts_li_utms'
                            });

                            utmParams['access_token'] = accessToken;

                            httpHelper.p('linked_in_user_demo_request', utmParams)
                                .then(function (response) {
                                    HStorageManager.remove({
                                        storageLevel: HStorageManager.StorageLevels.COOKIES,
                                        key: 'tts_li_utms'
                                    });
                                    hRedirect($stateParams.redirect || "/");
                                })
                                .catch(function (err) {
                                    hLog("harri.auth.social", "linked_in_user_demo_request", err);
                                });
                        }
                        else {
                            hAlert("Something went wrong", response.data.data.error || "Please try again later");
                        }

                    })
                        .catch(function (err) {
                            hLog("harri.auth.social", "auth_linkedin", err);
                        });
                }]
            })
    }]);
